import { Directive } from '@angular/core';
import { CdkPortal } from '@angular/cdk/portal';

/**
 * directive to catch tooltip content
 */
@Directive({
    selector: '[kalTooltipContent]',
    standalone: false
})
export class KalTooltipContentDirective extends CdkPortal  {
}
